// @ts-strict-ignore
import { Subject, Subscription } from 'rxjs';
import { bufferTime, filter } from 'rxjs/operators';
import { ArrayUtils } from '@shared/util/array-utils';
import { UserActionsLoggingService } from './user-actions-logging.service';
import { UserActionInfo } from '../../model/vo/user-action-info';
import { Injectable } from '@angular/core';
import { StringUtils } from '@shared/util/string-utils';

@Injectable({ providedIn: 'root' })
export class UserActionsLoggingManager {
  private actionStream: Subject<UserActionInfo> = new Subject<UserActionInfo>();
  private subscription: Subscription;
  private sessionId: string = StringUtils.createUuid().replace(/-/g, '');

  constructor(private loggingService: UserActionsLoggingService) {}

  public init(delay: number) {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.actionStream
      .pipe(
        bufferTime(delay),
        filter((actions: UserActionInfo[]) => ArrayUtils.isNotEmpty(actions))
      )
      .subscribe((actions: UserActionInfo[]) => {
        this.loggingService.logActions(actions, this.sessionId);
      });
  }

  public log(actionName: string, data: any = null): void {
    this.actionStream.next(new UserActionInfo(actionName, data, new Date()));
  }

  public logArticleAccessorySelection(articleId: number, accessoryArticleId: number): void {
    this.loggingService.logArticleAccessorySelection(articleId, accessoryArticleId);
  }

  public logFunction(func: string, params: string | boolean = null): void {
    this.loggingService.logFunction(func, params);
  }
}
